exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active[data-v-75268ceb], .fade-leave-active[data-v-75268ceb] {\n    transition: opacity .5s;\n}\n.fade-enter[data-v-75268ceb], .fade-leave-to[data-v-75268ceb] /* .fade-leave-active below version 2.1.8 */\n{\n    opacity: 0;\n}\n.hero-subheader[data-v-75268ceb] {\n    color: #008596;\n    background-image: url(/images/cover.svg?749fbe9…) !important;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: left;\n    background-attachment: fixed;\n}\n@media (min-width: 768px) {\n.hero-subheader[data-v-75268ceb] {\n        padding: 4.1rem 0px 4.2rem;\n}\n}\n\n", ""]);

// exports
